import { Injectable } from "@angular/core";
import { Router } from '@angular/router';
import { FormlyFieldConfig } from "@ngx-formly/core";
import { Observable } from "rxjs";
import { map } from 'rxjs/operators';
import { AuthorisedHub, CandidateProfile, EAAllocator, Employee, LookupField, RoleType } from 'src/app/core/api.gen';
import { CommonService } from 'src/app/core/common.service';
import { nullSafe } from 'src/app/utils';
import { isNullOrUndefined } from '../../../app/core/utils';
import { FieldTooltip } from "../../immigration/services/visatypes/field-tooltip.enum";
import { AuthService } from 'src/app/core/auth.service';
import { ActiveDirectoryService } from 'src/app/core/active-directory.service';
import {
    checkRange,


    EmailValidator, getArrayPickerField, getBigFourExpCheckboxNonMandatory, getButton, getDateField,
    getHiddenField, getInputField,
    getSelectField,
    getTelephoneField,
    getTypeAheadAirportSelectField, getTypeAheadField,
    getTypeAheadLocationSelectField, getTypeAheadSelectField, MinMaxAgeMustBe, setAsDisabled,
    setAsDisabledWhen, setAsDisabledWhenWithOutVal, setAsHiddenWhen,
    setAsNumeric, setAsRequired,
    setAsRequiredEmail,
    setAsRequiredForNotApplicable,
    setDisablePhoneFieldWhen,
    setDisableWhen,
    setDisablewithValueWhen, setPlaceholderNotApplicableWhen, setRegexValidation, setRequiredForNotApplicableWhen, setRequiredWhen,
    setYesNoValues
} from "../form/form-utils";
import { LookupTypeKeys } from '../lookup-type-keys';
import { StepType } from '../shared.module';
import { CandidateProfileMachineService } from './candidate-profile-machine.service';
import { isAfter } from "date-fns";
import { LookupFieldKeys } from "../lookup-fields-keys";


@Injectable(
  {
    providedIn: "root"
  }
)
export class ProfileStepService {

  private onBoardingTypes$: Observable<LookupField[]>;
  private officeLocationCountry$: Observable<LookupField[]>;
  private officeLocations$: Observable<LookupField[]>;
  private officeLegalEntities$: Observable<LookupField[]>;
  private employeeCategorys$: Observable<LookupField[]>;
  private yesNoNA$: Observable<LookupField[]>;
  private yesNo$: Observable<LookupField[]>;
  private contractTypes$: Observable<LookupField[]>;
  private serviceLines$: Observable<LookupField[]>;
  private subServiceLines$: Observable<LookupField[]>;
  private sectors$: Observable<LookupField[]>;
  private smus$: Observable<LookupField[]>;
  private specialities$: Observable<LookupField[]>;
  private ranks$: Observable<LookupField[]>;
  private ptcs$: Observable<Employee[]>;
  private recruiters$: Observable<Employee[]>;
  private previousEyExperience$: Observable<LookupField[]>;
  private genders$: Observable<LookupField[]>;
  private modeOfStudy$: Observable<LookupField[]>;
  private hireTypes$: Observable<LookupField[]>;

  private transferType$: Observable<LookupField[]>;
  private transferScenario$: Observable<LookupField[]>;
  private immigrationCaseType$: Observable<LookupField[]>;
  private currentVisaStatus$: Observable<LookupField[]>;
  private authurisedHubs$: Observable<AuthorisedHub[]>;
  private vaccinationStatus$: Observable<LookupField[]>;
  private vaccineType$: Observable<LookupField[]>;

  private maritalStatus$: Observable<LookupField[]>;
  private religion$: Observable<LookupField[]>;
  private rpCurrentEmployeeStatus$: Observable<LookupField[]>;
  private employeeOfficeLocation$: Observable<LookupField[]>;
  private countries$: Observable<LookupField[]>;
  private rpCurrentImmigrationStatus$: Observable<LookupField[]>;
  private dependents$: Observable<LookupField[]>;
  private traveltime$: Observable<LookupField[]>;
  private eosb$: Observable<LookupField[]>;
  private manageLeaveBalance$: Observable<LookupField[]>;
  private shortTravelType$: Observable<LookupField[]>;
  private choiceOfInsurance$: Observable<LookupField[]>;
  private cities$: Observable<LookupField[]>;
  private yesNoInitated$: Observable<LookupField[]>;
  private eaAllocators$: Observable<EAAllocator[]>;
  private workLocations$: Observable<LookupField[]>;
  private durations$: Observable<LookupField[]>;
  private contractStatus$: Observable<LookupField[]>;
  private itAssets$: Observable<LookupField[]>;
  private assetCourier$: Observable<LookupField[]>;
  private accessCard$: Observable<LookupField[]>;
  private nationality$: Observable<LookupField[]>;
  private yesNoMaybe$: Observable<LookupField[]>;
  private cEmpStatus$: Observable<LookupField[]>;
  private docAttestation$: Observable<LookupField[]>;
  private startDateStatus$: Observable<LookupField[]>;
  private flightAndHotelBookingOptions$: Observable<LookupField[]>;

 
  setCEDOnCDChange: (duration: number) => void;
  isCountryARE: () => boolean;
  rpAdditionalInfo: () => void;
  isLocationLevant: () => boolean;
  isLevantNational: () => boolean;
  isInternationalHire: () => boolean;
  isCNICNeeded: () => boolean;
  isRapidInnovation: () => boolean;
  isInternalTransfer: () => boolean;
  isPbNational: () => boolean;
  isIntern: () => boolean;
  isRapidOrPakistan: () => boolean;
  rank: () => string;
  officeLocation: () => number;
  modelDetails: () => CandidateProfile;
  officlck: (x) => boolean;
  validateAcademicAttesation: () => boolean;
  isPreviousEmployment: () => boolean;
  bigFourCompanies$: Observable<LookupField[]>;
  nationalityTypes$: Observable<LookupField[]>;
  cw_contractTypesExcludingFTTE: () => boolean;
  isNationalInternalTransferWithinSameOffice : () => boolean;


  constructor(private common: CommonService, private fsm: CandidateProfileMachineService, private route: Router,private authService: AuthService,private adService: ActiveDirectoryService) {
    this.loadCandidateLookups();
    this.loadPbAdditionalData();

  }

  loadPbAdditionalData() {
    this.transferType$ = this.common.prepareLookupObservable(LookupTypeKeys.TRANSFER_TYPES);
    this.transferScenario$ = this.common.prepareLookupObservable(LookupTypeKeys.TRANSFER_SCENARIO);
    this.immigrationCaseType$ = this.common.prepareLookupObservable(LookupTypeKeys.IMMIGRATION_CASE_TYPE);
    this.currentVisaStatus$ = this.common.prepareLookupObservable(LookupTypeKeys.CURRENT_VISA_STATUS);
  }


  loadCandidateLookups() {
    this.onBoardingTypes$ = this.common.prepareLookupObservable(
      LookupTypeKeys.ONBOARDING_TYPES
    );
    this.nationalityTypes$ = this.common.prepareLookupObservable(
      LookupTypeKeys.NATIONALITY_TYPE
    );
    this.officeLocationCountry$ = this.common.prepareLookupObservable(
      LookupTypeKeys.OFFICE_LOCATION_COUNTRY
    );
    this.officeLocations$ = this.common.prepareLookupObservable(
      LookupTypeKeys.OFFICE_LOCATION
    );
    this.officeLegalEntities$ = this.common.prepareOfficeEntityObservable();
    this.cities$ = this.common.prepareCitiesObservable();
    this.employeeCategorys$ = this.common.prepareEmployeeCategoryLookupObservable(
      LookupTypeKeys.EMPLOYEE_CATEGORY_TYPES
    );
    this.contractTypes$ = this.common.prepareContractTypeLookupObservable(
      LookupTypeKeys.CONTRACT_TYPES
    );
    this.eaAllocators$ = this.common.prepareEAallocatorObservable();
    this.serviceLines$ = this.common.prepareServiceLineObservable();
    this.subServiceLines$ = this.common.prepareSubServiceLineObservable();
    this.authurisedHubs$ = this.common.prepareAuthHubObservable();
    this.sectors$ = this.common.prepareSectorObservable();
    this.smus$ = this.common.prepareSMUObservable();
    this.specialities$ = this.common.prepareSpecialityObservable();
    this.ranks$ = this.common.prepareLookupObservable(LookupTypeKeys.RANK);

    this.ptcs$ = this.common.prepareEmployeeByRoleObservable(RoleType.PTC);
    this.recruiters$ = this.common.prepareEmployeeByRoleObservable(RoleType.Recruiter);

    this.previousEyExperience$ = this.common.prepareLookupObservable(LookupTypeKeys.PREVIOUS_EY_EXPERIENCE);
    this.genders$ = this.common.prepareLookupObservable(LookupTypeKeys.GENDER);
    this.modeOfStudy$ = this.common.prepareLookupObservable(LookupTypeKeys.MODE_OF_STUDY);
    this.hireTypes$ = this.common.prepareLookupObservable(LookupTypeKeys.HIRE_TYPE);
    this.yesNoNA$ = this.common.prepareLookupObservable(LookupTypeKeys.YESNONA_TYPES);
    this.yesNo$ = this.common.prepareLookupObservable(LookupTypeKeys.YESNO_TYPES);

    this.vaccinationStatus$ = this.common.prepareLookupObservable(LookupTypeKeys.VACCINATION_STATUS);
    this.vaccineType$ = this.common.prepareLookupObservable(LookupTypeKeys.VACCINE_TYPE);

    this.maritalStatus$ = this.common.prepareLookupObservable(LookupTypeKeys.MARITAL_STATUS);
    this.religion$ = this.common.prepareLookupObservable(LookupTypeKeys.RELIGION);
    this.rpCurrentEmployeeStatus$ = this.common.prepareLookupObservable(LookupTypeKeys.RP_CURRENT_EMPLOYEMENT_STATUS);
    this.employeeOfficeLocation$ = this.common.prepareLookupObservable(LookupTypeKeys.OFFICE_LOCATION);
    this.countries$ = this.common.prepareLookupObservable(LookupTypeKeys.NATIONALITY);
    this.traveltime$ = this.common.prepareLookupObservable(LookupTypeKeys.TRAVEL_TIME_PREFERNCE);
    this.dependents$ = this.common.prepareLookupObservable(LookupTypeKeys.NO_OF_DEPENDENTS);
    this.eosb$ = this.common.prepareLookupObservable(LookupTypeKeys.EOSB);
    this.manageLeaveBalance$ = this.common.prepareLookupObservable(LookupTypeKeys.MANAGE_LEAVE_BALANCE);
    this.shortTravelType$ = this.common.prepareLookupObservable(LookupTypeKeys.SHORT_TRAVEL_TYPE);
    this.choiceOfInsurance$ = this.common.prepareLookupObservable(LookupTypeKeys.CHOICE_OF_INSURANCE);
    this.yesNoInitated$ = this.common.prepareLookupObservable(LookupTypeKeys.YES_NO_INITATED);
    this.bigFourCompanies$ = this.common.prepareLookupObservable(LookupTypeKeys.BIGFOURCOMPANIES);
    this.workLocations$ = this.common.prepareLookupObservable(LookupTypeKeys.WORK_LOCATION);
    this.durations$ = this.common.prepareLookupObservable(LookupTypeKeys.DURATION);
    this.contractStatus$ = this.common.prepareLookupObservable(LookupTypeKeys.CONTRACT_STATUS);
    this.itAssets$ = this.common.prepareLookupObservable(LookupTypeKeys.IT_Assets);
    this.assetCourier$ = this.common.prepareLookupObservable(LookupTypeKeys.ASSET_COURIER);
    this.accessCard$ = this.common.prepareLookupObservable(LookupTypeKeys.ACCESS_CARD);
    this.nationality$ = this.common.prepareLookupObservable(LookupTypeKeys.NATIONALITY);
    this.yesNoMaybe$ = this.common.prepareLookupObservable(LookupTypeKeys.YESNOMAYBE_TYPES);
    this.cEmpStatus$ = this.common.prepareLookupObservable(LookupTypeKeys.CURRENT_EMPLOYEMENT_STATUS);
    this.docAttestation$ = this.common.prepareLookupObservable(LookupTypeKeys.DOCUMENT_ATTESTAION);
    this.startDateStatus$ = this.common.prepareLookupObservable(LookupTypeKeys.START_DATE_STATUS);
    this.flightAndHotelBookingOptions$ = this.common.prepareLookupObservable(LookupTypeKeys.HOTEL_AND_FLIGHT_BOOKING);

  }

  getProfileSteps(isinvite = false): StepType[] {

    return [
      {
        label: "Step 1",
        fields: [
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              getSelectField(
                "isConfidential",
                "Confidential",
                setYesNoValues(setAsRequired())
              ),
            ]
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              getInputField(
                "firstName",
                "First name (as per passport)",
                setAsRequired(setRegexValidation(/^[a-zA-Z -]*$/, 'Please enter a valid name'))
              ),
              getInputField(
                "middleName",
                "Middle name (as per passport)",
                setRegexValidation(/^[a-zA-Z -]*$/, 'Please enter a valid name')
              ),
              getInputField("lastName", "Last name (as per passport)",
                setAsRequired(setRegexValidation(/^[a-zA-Z -]*$/, 'Please enter a valid name')))
            ]
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              getInputField("referenceSystemID", "SF ID",
                setRequiredForNotApplicableWhen((model) => (![722, 725, 5971, 5972].includes(nullSafe<number>(() => model['employeeCategory'].id, -1)))
                  || (nullSafe<number>(() => model['contractType'].id, -1) === 1061),
               (setPlaceholderNotApplicableWhen((model) => this.cw_contractTypesExcludingFTTE())))),

             getInputField(
              "gui",
              "GUI",
              setRequiredWhen(
                // In invite mode: only 717. In non-invite: 717 or 722
                (model) => {
                  const cat = nullSafe<number>(() => model["employeeCategory"].id, -1);
                  return isinvite ? cat === 722 : [717, 722].includes(cat);
                },
                setAsHiddenWhen(
                  (model) => {
        
                const cat = nullSafe<number>(() => model["employeeCategory"].id, -1);
                return isinvite && cat === 717; // hide only for invite = 717

                  }
                   )
              )),

              getSelectField(
                "previousEYExperience.id",
                "Previous EY experience",
                this.common.getSelectFieldOptions(
                  this.previousEyExperience$,
                  "",
                  setAsHiddenWhen(
                    (model) => {
                      const cat = nullSafe<number>(() => model["employeeCategory"].id, -1);
                      return isinvite && ![717, 722].includes(cat); // hide only when not 717 or 722
                    },
                    setRequiredWhen(
                      (model) => {
                        const cat = nullSafe<number>(() => model["employeeCategory"].id, -1);
                        return isinvite && [717, 722].includes(cat); // required when 717 or 722
                      })
                  )
                ))
            ]
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              getInputField("emailID", "Email ID", setAsRequiredEmail(), 'col-md-4'),
              getTelephoneField("Contact number", setDisablePhoneFieldWhen(() => false,setAsHiddenWhen(() => isinvite)), 'col-md-4  pr-0 '),
              getSelectField(
                "onboardingType.id",
                "Pre-boarding type",
                this.common.getSelectFieldOptions(this.onBoardingTypes$, '',
                  setAsRequired())
              )
            ]
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              // getSelectField(
              //   "employeeCategory.id",
              //   "Employee category",
              //   this.common.getEmpCategoryOptions(
              //     this.employeeCategorys$.pipe(map(items => items.filter(f => ![12408].includes(f.id)))),
              //     '', 
              //     setAsRequired())
              // ),
            getSelectField(
                "workLocation",
                "Candidate Work Location",
                this.common.getSelectFieldOptions(this.workLocations$, '',
                  setAsHiddenWhen(() => !this.cw_contractTypesExcludingFTTE())
              )),
              getSelectField(
                "employeeCategory.id",
                "Employee category",
                this.common.getEmpCategoryOptionsWithFilter(
                  this.employeeCategorys$.pipe(map(items => items.filter(f => ![12408].includes(f.id)))),    
                 [],LookupFieldKeys.EXCLUDED_EMP_CATEGORY_IDS,      
                  setAsRequired())
              ),
                getSelectField(
                "contractType.id",
                "Contract type",
                this.common.getContractTypeSelectFieldWithParentDisableOptions(
                  this.contractTypes$,
                  LookupFieldKeys.EXCLUDED_CONTRACT_TYPE_IDS,
                  "employeeCategory.id",
                  setAsRequired()
                )
              ),

              getSelectField(
                "contractStatus",
                "Contract Status",
                this.common.getSelectFieldOptions(
                  this.contractStatus$,
                   '',
                  setAsHiddenWhen(() => !this.cw_contractTypesExcludingFTTE())
                )
              ),

              //contract duration for all except interns and CW excluding FTTE
                getInputField("contractDuration", "Contract duration (months)",
                    setAsRequired(
                      checkRange(0, 60,
                        "Contract Duration should not be more than 60 months",
                        setAsHiddenWhen(() => (this.isIntern() || this.cw_contractTypesExcludingFTTE()),
                          this.common.executeConfirmedEndDate(this.setCEDOnCDChange,setAsNumeric())
                        )
                      )
                    )
                ),
             
              //contract duration only for interns
              getInputField("contractDurationIntern", "Contract duration", setAsRequired(setAsHiddenWhen(() => !this.isIntern()))),

              //contract  duration only for contract types excluding CW FTTES
               getInputField("contractDurationCW", "Contract duration", setAsRequired(setAsHiddenWhen(() => !this.cw_contractTypesExcludingFTTE(),setAsNumeric()))),
                getSelectField(
                "durationInCW",
                "Contract duration type",
                this.common.getSelectFieldOptions(this.durations$, '',
                  setAsHiddenWhen(() => !this.cw_contractTypesExcludingFTTE(),
                  setAsRequired())
              ))
            ]
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [         
              getSelectField(
                "officeLocationCountry.id",
                "Office location country",
                this.common.getSelectFieldOptionsWithEmployeeCategory(this.officeLocationCountry$, '',
                  setAsRequired())
              ),
              getSelectField(
                "officeLocation.id",
                "Office location",
                this.common.getSelectFieldWithParentDisableOptions(this.officeLocations$,[4859,15201], "officeLocationCountry.id",
                  setAsRequired()
                )
              ),
              getSelectField(
                "officeLegalEntity.id",
                "Office legal entity",
                this.common.getSelectFieldOptions(this.officeLegalEntities$, "officeLocationCountry.id", 
                  setRequiredWhen(()=>!this.cw_contractTypesExcludingFTTE()))),
              getSelectField(
                "nationalityType.id",
                "Nationality Type",
                this.common.getNationalityTypeSelectFieldOptions(this.nationalityTypes$, '', setRequiredWhen(() => (!this.common.isRecruitment && !this.cw_contractTypesExcludingFTTE())))
              )                      
            ]
          }
        ]
      },
      {
        label: "Step 2",
        fields: [
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              getSelectField(
                "serviceLine.id",
                "Service line",
                this.common.getSelectFieldOptions(this.serviceLines$, '',
                  setAsRequired())
              ),
              getSelectField(
                "subServiceLine.id",
                "Sub-service line",
                this.common.getSelectFieldOptions(this.subServiceLines$, "serviceLine.id",
                  setAsRequired())
              ),
              // getHiddenField(
              //   "smu.id",
              //   //"Sub-sub-service line/ competency"
              //   //,this.common.getSelectFieldOptions(this.smus$, "subServiceLine.id", setAsHiddenWhen(x=>true))
              // ),
              getSelectField(
                "speciality.id",
                "Specialty",
                this.common.getSelectFieldOptions(this.specialities$, "subServiceLine.id", setAsRequired())
              )
            ]
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              getSelectField(
                "sector.id",
                "Industry - sector",
                this.common.getSelectFieldOptions(this.sectors$,
                  "serviceLine.id", setAsRequired())
              ),
              getSelectField(
                "deptCode",
                "Department",
                this.common.getDepartmentSelectFieldOption(setAsRequired())
              ),
              getInputField(
                "costCentre",
                "Cost Centre", setAsDisabled()),
              // getInputField("sslMapping", "SSL mapping", setRequiredWhen((model) => {
              //   return nullSafe<number>(() => model['serviceLine'].id, -1) == 259
              // },
              //   setAsHiddenWhen((model) => {

              //     return nullSafe<number>(() => model['serviceLine'].id, -1) != 259
              //   }))),
              // getInputField("academicQualification", "Academic qualification",
              //  setPlaceholderNotApplicableWhen((model) => this.cw_contractTypesExcludingFTTE(), setAsHiddenWhen(() => isinvite))
              // )
             ,//getInputField(
              //  "buCode",
              //  "Business unit", setAsDisabled()),
              //getInputField(
              //  "ouCode",
              //  "Operation unit", setAsDisabled()),
              //getInputField(
              //  "muCode",
              //  "Managerial unit", setAsDisabled()),
              getSelectField(
                "job.rank",
                "Rank",
                this.common.getRankSelectFieldOptions(
                  setAsRequired())
              ),
              getSelectField(
                "job.jobCode",
                "Grade",
                this.common.getGradeSelectFieldOptions(setAsRequired())
              ),
              getInputField("jobTitle", "Job title", setAsRequiredForNotApplicable(setPlaceholderNotApplicableWhen((model) => this.cw_contractTypesExcludingFTTE()))),
              
              getSelectField(
                "isBRIT.id",
                "Is this a business requested internal transfer?",
                this.common.getISBritSelectFieldOptions(this.yesNoNA$, "employeeCategory.id",
                  setRequiredWhen(()=>!this.cw_contractTypesExcludingFTTE)
                )),
              getInputField("visaNumber", "Visa number"
                , setRequiredForNotApplicableWhen((model) => ( 
                  ([1045].includes(nullSafe<number>(() => model['onboardingType'].id, -1))) && ([729].includes(nullSafe<number>(() => model['hireType'].id, -1))) &&
                  ([1048].includes(nullSafe<number>(() => model['officeLocationCountry'].id, -1)))),setPlaceholderNotApplicableWhen(()=>this.cw_contractTypesExcludingFTTE()))
                , 'col-md-4')
              ,
              getInputField("visanNoAndDesignation", "Visa designation"
                , setRequiredForNotApplicableWhen((model) => (
                  ([1045].includes(nullSafe<number>(() => model['onboardingType'].id, -1))) && ([729].includes(nullSafe<number>(() => model['hireType'].id, -1))) &&
                  ([1048].includes(nullSafe<number>(() => model['officeLocationCountry'].id, -1)))),setPlaceholderNotApplicableWhen(()=>this.cw_contractTypesExcludingFTTE()))
                , 'col-md-4')
              ,
              getSelectField(
                "portOfExitCountryId",
                "Port of exit - country",
                this.common.getSelectFieldOptions(this.countries$, '',
                setRequiredForNotApplicableWhen((model) => (
                  ([1045].includes(nullSafe<number>(() => model['onboardingType'].id, -1))) && ([729].includes(nullSafe<number>(() => model['hireType'].id, -1))) &&
                  ([1048].includes(nullSafe<number>(() => model['officeLocationCountry'].id, -1)))),setPlaceholderNotApplicableWhen(()=>this.cw_contractTypesExcludingFTTE())))
              ),
              getSelectField(
                "portOfExitCityId",
                "Port of exit - city",
                this.common.getSelectFieldOptions(this.cities$, "portOfExitCountryId",
                setRequiredForNotApplicableWhen((model) => (
                  ([1045].includes(nullSafe<number>(() => model['onboardingType'].id, -1))) && ([729].includes(nullSafe<number>(() => model['hireType'].id, -1))) &&
                  ([1048].includes(nullSafe<number>(() => model['officeLocationCountry'].id, -1))))
                  ,setPlaceholderNotApplicableWhen(()=>this.cw_contractTypesExcludingFTTE())
                ))
              ),            
           getInputField(
             "degree",
             "",
             setRequiredForNotApplicableWhen((model) => (
               ([1045].includes(nullSafe<number>(() => model['onboardingType'].id, -1))) &&
               ([729].includes(nullSafe<number>(() => model['hireType'].id, -1))) &&
               ([1048].includes(nullSafe<number>(() => model['officeLocationCountry'].id, -1)))
             ),
             setPlaceholderNotApplicableWhen(() => this.cw_contractTypesExcludingFTTE(),
            // ),
             //'col-md-4',
             {
               expressionProperties: {
                 'templateOptions.label': () =>
                   this.cw_contractTypesExcludingFTTE() ? "Degree" : "Degree Used for Visa Tagging"
               }
             }
           )))
            ]
          },
        ]
      },
      {
        label: "Step 3",
        fields: [
          {
            fieldGroupClassName: "row",
            fieldGroup: [
            getInputField(
                "signOnBonus",
                "Sign-on-bonus",
                setRequiredForNotApplicableWhen(
                  (model) => (![5971, 5972].includes(nullSafe<number>(() => model['employeeCategory'].id, -1)) && !this.cw_contractTypesExcludingFTTE()),
                  setPlaceholderNotApplicableWhen(() => this.cw_contractTypesExcludingFTTE())
                ),'col-md-4'),
              getSelectField("otc.id", "PJC name", setAsRequired(this.common.getEmployeeSelectFieldOptions(this.ptcs$))),
              getInputField("ptcGUI", "PJC GUI", this.common.getPJCGUI()),
              getTypeAheadField("pjcAdminData", "PJC admin", ),
              getSelectField("recruiter.id", "Recruiter name", setAsRequired(this.common.getEmployeeSelectFieldOptions(this.recruiters$))),
              //getTypeAheadField("recruitmentAdminData", "Recruitment admin", setAsRequired()),
              getTypeAheadField(
  "recruitmentAdminData",
  "Recruitment admin",
  setAsRequired({
    
hooks: {
  onInit: (field) => {
    // Only when empty
    const hasModel = !!field.model?.recruitmentAdminData;
    const hasControl = !!field.formControl?.value;
    if (hasModel || hasControl) return;

    const me = this.authService.ActiveUser;
    const term = me?.displayName || me?.email || this.authService.AdUserName || '';
    if (!term || term.length < 3) return;

    this.adService.getAdUsers(term).subscribe((results) => {
      if (!Array.isArray(results) || results.length === 0) return;

      const match =
        results.find(r => r?.userPrincipalName?.toLowerCase() === (me?.email || '').toLowerCase()) ||
        results.find(r => r?.displayName?.toLowerCase() === (me?.displayName || '').toLowerCase());

      if (!match) return;

      // Re-check to avoid overwriting user input
      if (field.model?.recruitmentAdminData || field.formControl?.value) return;

      // Set the value but keep the form pristine
      field.formControl.setValue(match, { emitEvent: true });
      field.formControl.updateValueAndValidity({ emitEvent: true });
      field.form?.updateValueAndValidity({ emitEvent: true });

      //  Ensure Save stays disabled on reopen (no user edit yet)
      field.formControl.markAsPristine();
      field.formControl.markAsUntouched();
      field.form?.markAsPristine();
      field.form?.markAsUntouched();
    });
  },
},

  })
),

              getTypeAheadField("hiringManagerData", "Hiring manager name", setAsRequired()),
              getTypeAheadField("additionalManagerData", "Additional manager name"),
              getTypeAheadField("buddyAllocatorData", "Buddy allocator",setPlaceholderNotApplicableWhen(()=>this.cw_contractTypesExcludingFTTE())),
              getTypeAheadField("counselorAllocatorData", "Counselor allocator",setPlaceholderNotApplicableWhen(()=>this.cw_contractTypesExcludingFTTE())),
              getSelectField("eAallocatorId", "EA Allocator", this.common.getEAallocatorSelectFieldOptions(this.eaAllocators$, '',setAsHiddenWhen(
                  (model) => !['11', '13'].includes(nullSafe<string>(() => model.job.rank))))),

              getSelectField("additionalEAallocatorId", "Additional EA Allocator", this.common.getEAallocatorSelectFieldOptions(this.eaAllocators$,'additional',
                setAsHiddenWhen(
                  (model) => !['11', '13'].includes(nullSafe<string>(() => model.job.rank))))),

              getTypeAheadField("referralData", "Referred by"),
              getSelectField("hireType.id", "Hire type", this.common.getSelectFieldOptions(this.hireTypes$, '',
              setRequiredWhen(()=>!this.cw_contractTypesExcludingFTTE()))),
              getSelectField(
                "biLingual.id",
                "Bi-lingual (arabic speaker)",
                this.common.getSelectFieldOptions(this.yesNo$, '')),
              getSelectField("gender.id", "Gender", this.common.getSelectFieldOptions(this.genders$, '', setRequiredWhen(() => (!isinvite), (setDisablewithValueWhen(() => isinvite))))),
              getSelectField(
                "nationality.id",
                "Nationality",
                this.common.getNationalityFieldOptions(setRequiredWhen(() => (!isinvite)), isinvite)
              ),
              getDateField("dateOfBirth", "Date of birth",
                setRequiredWhen(() => (!isinvite), setDisablewithValueWhen(() => isinvite,
                  setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
                    "Please enter a valid date in 'dd-mm-yyyy' format",
                    MinMaxAgeMustBe(10, 100, 'Date of birth cannot be in the past 10 years or in the future')
                  ))
                )
              ),
               getSelectField(
                "isContractWithEYMena",
                "Does the new joiner currently have a contract with EY MENA under another category?",
                this.common.getSelectFieldOptions(this.yesNo$,'',
                  setAsHiddenWhen(() => !this.cw_contractTypesExcludingFTTE()))
                ),
                getSelectField(
                "itAsset",
                "IT Assets",
                this.common.getSelectFieldOptions(this.itAssets$,'',
                  setAsHiddenWhen(() => !this.cw_contractTypesExcludingFTTE() || this.route.url.indexOf('pre-boarding') > 0 ,
                setRequiredWhen(()=>this.cw_contractTypesExcludingFTTE()))
                )),
               getSelectField(
                "assetCourier",
                "Asset Courier",
                this.common.getSelectFieldOptions(this.assetCourier$,'',
                  setAsHiddenWhen(() => !this.cw_contractTypesExcludingFTTE(),
                 setRequiredWhen(()=>this.cw_contractTypesExcludingFTTE()))
                )),
               getSelectField(
                "accessCard",
                "Access card",
                this.common.getSelectFieldOptions(this.accessCard$,'',
                  setAsHiddenWhen(() => !this.cw_contractTypesExcludingFTTE(),
                 setRequiredWhen(()=>this.cw_contractTypesExcludingFTTE()))
                )),

              getSelectField(
                "vaccinationStatus.id",
                "Vaccination status",
                this.common.getSelectFieldOptions(this.vaccinationStatus$, '',
                  (setDisablewithValueWhen(() => isinvite,setPlaceholderNotApplicableWhen(()=>this.cw_contractTypesExcludingFTTE()))))),

                          // todo: make the disabled when required when conditions single lined
              getSelectField(
                "vaccineType.id",
                "Vaccine type",
                this.common.getSelectFieldOptions(this.vaccineType$, '',
                  setRequiredForNotApplicableWhen(
                    (model) => {
                      if (isinvite) {
                        return false;
                      } else {
                        return (model.vaccinationStatus.id === 12001 || model.vaccinationStatus.id === 12002);
                      }
                    },
                    setDisablewithValueWhen((model) => {
                      if (isinvite) {
                        return true;
                      } else {
                        return (model.vaccinationStatus.id !== 12001 && model.vaccinationStatus.id !== 12002);
                      }
                    },setPlaceholderNotApplicableWhen(()=>this.cw_contractTypesExcludingFTTE()))
                  )
                )
              ),
            
              getInputField(
                "otherVaccineName",
                "Other vaccine name",
                setRequiredForNotApplicableWhen((model) => {
                  if (isinvite) {
                    return false;
                  } else {
                    return model.vaccineType.id === 12014;
                  }
                },
                  setDisablewithValueWhen((model) => {
                    if (isinvite) {
                      return true;
                    } else {
                      return model.vaccineType.id !== 12014;
                    }
                  },setPlaceholderNotApplicableWhen(()=>this.cw_contractTypesExcludingFTTE())
                ))
              ),
              getDateField("invitedDate", "Profile invited date", setAsDisabled(
                setAsHiddenWhen((model) => isNullOrUndefined(model['invitedDate']))
              )),
              getDateField("recruitmentHandoverDate", "Profile approved date", setAsDisabled(
                setAsHiddenWhen((model) => isNullOrUndefined(model['recruitmentHandoverDate'])))),
              getDateField("startDate", "Start date", setAsDisabled()),
              getInputField(
                "currentEmploymentStatus",
                "Current employment status", setAsDisabled(setAsHiddenWhen(()=>this.cw_contractTypesExcludingFTTE()))),
              getInputField(
                "eyVisaLCStatus",
                "EY Visa/LC status", setAsDisabled()),
              getInputField("probationPeriod", "Probation Period (months)",
                setAsNumeric(this.common.getProbationFieldVaule(setAsRequiredForNotApplicable(checkRange(0, 20, "Probation Period should not be more than 20 months"
                  , setPlaceholderNotApplicableWhen(()=>this.cw_contractTypesExcludingFTTE(), this.common.AddTooltipToControl(FieldTooltip.ProbationPeriod))               
                ))))),
                  
                // getInputField("noticePeriodCW", "Notice Period (months)"),
                // setAsNumeric(this.common.getProbationFieldVaule(setAsHiddenWhen(()=>!this.cw_contractTypesExcludingFTTE(),setAsRequired()))),

                  getTypeAheadSelectField(
                    "authorisedHub",
                    "Authorised hub",
                    this.common.getTypeAheadSelectFieldOptions(this.authurisedHubs$, '',
                      setAsRequiredForNotApplicable(setAsDisabledWhen(() => !this.common.isRecruitment ,setPlaceholderNotApplicableWhen(()=>this.cw_contractTypesExcludingFTTE())
                      )))),
              getSelectField(
                "transferTypeID",
                "Transfer type",
                this.common.getSelectFieldOptions(this.transferType$, '', setAsRequiredForNotApplicable(
                  setAsHiddenWhen(() => this.route.url.indexOf('pre-boarding') > 0 ,setPlaceholderNotApplicableWhen(()=>this.cw_contractTypesExcludingFTTE()))))),
              getSelectField(
                "transferScenarioID",
                "Transfer scenario",
                this.common.getScenarioSelectFields(this.transferScenario$, 'transferTypeID',
                   setAsRequiredForNotApplicable(setAsHiddenWhen(() => this.route.url.indexOf('pre-boarding') > 0 ,setPlaceholderNotApplicableWhen(()=>this.cw_contractTypesExcludingFTTE()))))),
              getSelectField(
                "isBuddyApplicableId",
                "Is Buddy Applicable?",
                this.common.getSelectFieldOptions(this.yesNo$, '', setRequiredForNotApplicableWhen((model) => [717,5972].includes(nullSafe<number>(() => model['employeeCategory'].id, -1)),
                setPlaceholderNotApplicableWhen(()=>this.cw_contractTypesExcludingFTTE())
                )
                )),
              getSelectField(
                "isCounselorChangeRequiredId",
                "Counselor change required?",
                this.common.getSelectFieldOptions(this.yesNo$, '', setRequiredForNotApplicableWhen((model) => [717,5972].includes(nullSafe<number>(() => model['employeeCategory'].id, -1)),setPlaceholderNotApplicableWhen(()=>this.cw_contractTypesExcludingFTTE()))
                )),
              getSelectField(
                "isCounseleesRetainedId",
                "Will existing counselees be retained?",
                this.common.getSelectFieldOptions(this.yesNo$, '', setRequiredForNotApplicableWhen((model) => [717,5972].includes(nullSafe<number>(() => model['employeeCategory'].id, -1)),setPlaceholderNotApplicableWhen(()=>this.cw_contractTypesExcludingFTTE()))
                )),
            ],
          },

          // Contigent worker workflow fields from PJ -- START
          {
            fieldGroupClassName: "row",
            hideExpression: () => !this.cw_contractTypesExcludingFTTE() || this.route.url.indexOf('pre-boarding') > 0,
            fieldGroup: [
             getSelectField(
               "currentLocationCountryID",
               "Current location - country",
               this.common.getSelectFieldOptions(this.nationality$, '', setAsRequired())),
             getSelectField(
                "currentLocationId",
                "Current location - city",
                this.common.getSelectFieldOptions(this.cities$, 'currentLocationCountryID', setAsRequired())),
               getInputField("gpn", "GPN"),
             
               getDateField("lastWorkingday",
                "Last working day/earliest availability to join",
                  setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
                    "Please enter a valid date in 'dd-mm-yyyy' format",setAsRequired()),
                ),


              getInputField("noticePeriodCW",
                "Notice period (Days)",
                setAsRequired(checkRange(-1, 200, 'Value should not be greater than 200',
                  setAsRequired()),            
                )),
             
                getSelectField(
                "isNPNegotiableId",
                "Is notice period negotiable?",
                this.common.getSelectFieldOptions(this.yesNoMaybe$, '',  setAsRequired())),

               getSelectField(
                "currentEmploymentStatusID",
                "Current employment status",
                this.common.getSelectFieldOptions(this.cEmpStatus$, '', setAsRequired())),

               getDateField("epRequestedDate",
                "Employee profile requested date",
                  setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
                    "Please enter a valid date in 'dd-mm-yyyy' format"),
                ),

              getDateField("epCreatedDate", "Employee profile created date", 
                 setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
                    "Please enter a valid date in 'dd-mm-yyyy' format"),),

              getSelectField(
              "eduDocAttestationId",
              "Education document attestation",
              this.common.getSelectFieldOptions(this.docAttestation$, '', setAsRequired())),

             getInputField("chargeCode", "Charge code", setAsRequired(setDisableWhen((model) =>
               nullSafe<number>(() => model['transferTypeID'], -1) === 982)
             )),
             getSelectField(
                "dualCitizenshipId",
                "Dual citizenship",
                this.common.getSelectFieldOptions(this.yesNo$, '')),
              getSelectField(
                "secondNationalityId", "Second nationality",
                this.common.getSelectFieldOptions(this.nationality$, '',
                  setDisableWhen((model) =>
                    isNullOrUndefined(model['dualCitizenshipId']) || model['dualCitizenshipId'] !== 1074,
                    setRequiredWhen((model) =>
                      !isNullOrUndefined(model['dualCitizenshipId']) && model['dualCitizenshipId'] === 1074)
                  ))
              ),
              getInputField("approvedPreHireExceptions", "Approved pre-hire exceptions"),
            , getSelectField(
                "flightBookingID",
                "Flight booking Eligibility",
                this.common.getSelectFieldOptions(this.flightAndHotelBookingOptions$, '', setAsRequired())),
              getSelectField(
                "hotelBookingID",
                "Hotel booking Eligibility",
                this.common.getSelectFieldOptions(this.flightAndHotelBookingOptions$, '', setAsRequired())),

              getDateField("startDateCW", "Start date",
              setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
              "Please enter a valid date in 'dd-mm-yyyy' format")),

             getSelectField(
                "startdateStatusIdCW",
                "Start date status",
                this.common.getSelectFieldOptions(this.startDateStatus$, '')),
            
            getDateField("confirmedEnddateCW","Confirmed end date",
               setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
              "Please enter a valid date in 'dd-mm-yyyy' format")),
            ]
          },
                // Contigent worker workflow fields from PJ -- END
           {
            fieldGroupClassName: "row",
            fieldGroup: [
             getButton("rploadbtn", "Open additional info", this.rpAdditionalInfo, "outline-primary", setAsHiddenWhen(() => this.route.url.indexOf('pre-boarding/pb-profile') > 0))

            ]
           }
        ]
      }
    ];
  }

  getAdditionalPbSteps(model: CandidateProfile): StepType[] {
    return [{
      label: "step 1",
      fields: [
        {
          fieldGroupClassName: 'row',
          fieldGroup: []
        },
        {
          fieldGroupClassName: 'row',
          fieldGroup: [
            getSelectField(
              "transferTypeID",
              "Transfer type",
              this.common.getSelectFieldOptions(this.transferType$, '', setAsRequiredForNotApplicable(setPlaceholderNotApplicableWhen(()=>this.cw_contractTypesExcludingFTTE())))),
            getSelectField(
              "transferScenarioID",
              "Transfer scenario",
              this.common.getScenarioSelectFieldsWithValue(this.transferScenario$, 'transferTypeID', setAsRequiredForNotApplicable(setPlaceholderNotApplicableWhen(()=>this.cw_contractTypesExcludingFTTE())))),
            getSelectField(
              "immigrationCaseTypeID",
              "Immigration case type",
              this.common.getSelectFieldOptions(this.getImmigrationTypes(model), '',
                this.common.setCovidScenario('Office location country must be UAE for this type', this.isCountryARE,
                   setAsRequiredForNotApplicable(setPlaceholderNotApplicableWhen(()=>this.cw_contractTypesExcludingFTTE())))))
          ]
        },
        {
          fieldGroupClassName: 'row',
          fieldGroup: [
            getSelectField(
              "currentVisaStatusID",
              "Current visa status",
              this.common.getSelectFieldOptions(this.getCurrentVisaStatus(model),'', setAsRequired())),
            getDateField("profileSubmittedDate", "Profile submitted date", setAsDisabled(
              setAsHiddenWhen((model) => isNullOrUndefined(model['profileSubmittedDate'])),             
            )),
            ]
        }
      ]
    },
    ];
  }

  getRpProfileStep(): StepType[] {

    return [
      {
        label: 'step 1',
        fields: [
          {
            fieldGroupClassName: 'row',
            fieldGroup: [
              getInputField(
                "arabicName.arabicFirstName",
                "Arabic first name",setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE())
              ),
              getInputField(
                "arabicName.arabicMiddleName",
                "Arabic middle name",setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE())
              ),
              getInputField(
                "arabicName.arabicLastName",
                "Arabic last name",setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE())
              ),

            ]
          },
          {
            fieldGroupClassName: 'row',
            fieldGroup: [
 
              getSelectField(
                "preferredMail.isPreferedNameApplicable.id",
                "Would you like to use your preferred name for EY Email ID?",
                this.common.getSelectFieldOptions(
                  this.yesNo$,
                  '',
                  setPlaceholderNotApplicableWhen(() => this.cw_contractTypesExcludingFTTE())
                )
              ),
              getInputField(
                "preferredMail.pfirstname",
                "Preferred first name"
              ),
              getInputField(
                "preferredMail.psecondname",
                "Preferred middle name"
              ),
              getInputField(
                "preferredMail.plastname",
                "Preferred last name"
              ),
              
              {
                key: 'preferredMail.selectedPrefName',
                type: 'select',
                className:  'col-md-4 mb-3',
                templateOptions: {
                  placeholder: "Select",
                  label: 'Selected preferred name',
                  attributes: {
                    class: 'form-control form-control-sm'
                  }//,
                  
                  //options: [],
                },
                expressionProperties: {
                      // 'templateOptions.placeholder': (model) =>
                      //  this.cw_contractTypesExcludingFTTE() ? 'Not Applicable' : 'Select',

                    'templateOptions.options': (model, formState, field) => {
                      // Retrieve the selected category value from the model
                      const pfirstname = model?.preferredMail?.pfirstname;
                      const psecondname = model?.preferredMail?.psecondname;
                      const plastname = model?.preferredMail?.plastname;
                     let prefrednameList=[]
                     type objects = {
                      label: string;
                      value: string;
                  }
                  
                  const user01 = {} as objects;
                  const user02 = {} as objects;
                  const user03 = {} as objects;
                  const user04 = {} as objects;
                    
                     if (pfirstname && pfirstname.length > 0 && plastname && plastname.length > 0) {
                      user01.label=pfirstname + ' ' + plastname;
                      user01.value=pfirstname + ' ' + plastname;
                      prefrednameList.push(user01);
                    }
                    if (psecondname && psecondname.length > 0 && plastname && plastname.length > 0) {
                      user02.label=psecondname + ' ' + plastname;
                      user02.value=psecondname + ' ' + plastname;
                      prefrednameList.push(user02);

                      user03.label=pfirstname + ' ' + psecondname[0] + ' ' + plastname;
                      user03.value=pfirstname + ' ' + psecondname[0] + ' ' + plastname;
                      prefrednameList.push(user03);

                    }
                    if (psecondname && psecondname.length > 1 && pfirstname&&pfirstname.length > 0 && plastname && plastname.length > 0) {
                      user04.label=pfirstname + ' ' + psecondname + ' ' + plastname;
                      user04.value=pfirstname + ' ' + psecondname + ' ' + plastname;
                      prefrednameList.push(user04);

                    }
                    return prefrednameList;
                    }}
              }
            ]
          },

          {
            fieldGroupClassName: 'row',
            fieldGroup: [
              getInputField(
                "passportNumber",
                "Passport number"
              ),
             getDateField(
               "passportExpiryDate",
               "Passport expiry date"
             ),
              getSelectField(
                "currentEmploymentStatus.id",
                "Current employment status",
                this.common.getSelectFieldOptions(this.rpCurrentEmployeeStatus$, '', setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE()))
              ),
            ]
          },

          {
            fieldGroupClassName: 'row',
            fieldGroup: [
              getInputField(
                "address.building",
                "Building",setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE())
              ),
              getInputField(
                "address.city",
                "City",setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE())
              ),
              getInputField(
                "address.street",
                "Street",setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE())
              ),

            ]
          },
          {
            fieldGroupClassName: 'row',
            fieldGroup: [
              getInputField(
                "socialSecurityNumber",
                "Social security number", setAsHiddenWhen(() => !this.isLevantNational(),setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE()))
              ),
              getInputField(
                "nationalIdNumber",
                "National id number", setAsHiddenWhen(() => !this.isLevantNational(),setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE()))
              )
            ]
          },
          {
            fieldGroupClassName: 'row',
            fieldGroup: [
              getSelectField(
                "insuranceDetils.insuranceExist.id",
                "Do you have an existing Medical Insurance plan?",
                this.common.getSelectFieldOptions(this.yesNo$, '', setAsHiddenWhen(this.isLocationLevant,setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE())))
              ),
              getSelectField(
                "insuranceDetils.isItGovtInsurance.id",
                "If yes, is it provided by a Government entity?",
                this.common.getSelectFieldOptions(this.yesNo$, '', setRequiredWhen((model) => !this.isLocationLevant() && model.insuranceDetils.insuranceExist && model.insuranceDetils.insuranceExist.id == 1074, 
                setAsHiddenWhen(this.isLocationLevant,
                  setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE()))))
              ),
            ]
          },
          {
            fieldGroupClassName: 'row',
            fieldGroup: [
              getSelectField(
                "religion.id",
                "Religion",
                this.common.getSelectFieldOptions(this.religion$, '',setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE()))
              ),
            
              getSelectField("bankDetails.isBankAvailable.id", "Do you have bank account in the office location you are joining?",
                this.common.getSelectFieldOptions(this.yesNo$,'',setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE()))
              ),
              getInputField(
                "bankDetails.gccBankName",
                "Bank name",setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE())
              ),
            ]
          },
          {
            fieldGroupClassName: 'row',
            fieldGroup: [
              getInputField(
                "bankDetails.gccBankAccount",
                "Bank account",setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE())
              ),
              getInputField(
                "bankDetails.ibanNumber",
                "IBAN number",setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE())
              ),
              getTypeAheadLocationSelectField(
                "previousEyLocation",
                "Previous EY location",setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE())
              ),
            ]
          },
          {
            fieldGroupClassName: 'row',
            fieldGroup: [
              getSelectField(
                "travelPlan.id",
                "Travel plan",
                this.common.getSelectFieldOptions(this.yesNo$, '',
                  this.common.AddTooltipToControl(FieldTooltip.TravelPlan))
              ),
              getInputField(
                "professionalQualification",
                "Professional qualification(s) ",setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE())
              ),
              getSelectField(
                "professionalQualificationAttested.id",
                "Attested Professional qualification",
                this.common.getSelectFieldOptions(this.yesNoInitated$, '',
                setAsHiddenWhen(this.validateAcademicAttesation,
                  this.common.AddTooltipToControl(FieldTooltip.AttestedProfessionalqualification))
                  )
              ),
              
            ]
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              getArrayPickerField('profession', 'Academic Qualification Details', this.academicDetails('academic qualifications'), 'Academic Qualifications', null, null, 'View',null,null,null,true),
             

              getInputField('personalEmailAddress', "Personal Email ID", 
                setRegexValidation(
                  /^\w+([\.]?[\-\_\w+])*@\w+([\.-]?\w+)*(\.\w{2,})(?<!\.ey.com)$/,
                  'Please enter a valid email address',
                  null))
            ]
          },
          {
            fieldGroupClassName: 'row',
            fieldGroup: [



              // getInputField(
              //   "currentImmigrationStatus",
              //   "Current immigration status", setAsRequired()
              // ),
              getDateField(
                "currentVisaExpiryDate",
                "Current visa expiry date",
                setAsHiddenWhen(() => this.isPbNational())
              ),
              getSelectField(
                "residentHiringOffice.id",
                "Resident - hiring office location", setAsHiddenWhen(() => this.isPbNational(),
                  this.common.getSelectFieldOptions(this.yesNo$, '', this.common.AddTooltipToControl(FieldTooltip.Residenthiringofficelocation)))
              )
            ]
          },
          {
            fieldGroupClassName: 'row',
            fieldGroup: [
              getInputField(
                "additionalInfo.fathersFullName",
                "Father's full name",setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE())
              ),
              getInputField(
                "additionalInfo.mothersFullName",
                "Mother's full name",setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE())
              ),
              getSelectField(
                "additionalInfo.fathersNationality.id",
                "Father's nationality",
                this.common.getSelectFieldOptions(this.countries$, '', setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE()))
              )
            ]
          },
          {
            fieldGroupClassName: 'row',
            fieldGroup: [
              getSelectField(
                "additionalInfo.mothersNationality.id",
                "Mother's nationality",
                this.common.getSelectFieldOptions(this.countries$, '',setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE()))
              ),
              getSelectField(
                "additionalInfo.fathersReligion.id",
                "Father's religion",
                this.common.getSelectFieldOptions(this.religion$, '', setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE()))
              ),
              getSelectField(
                "additionalInfo.mothersReligion.id",
                "Mother's religion",
                this.common.getSelectFieldOptions(this.religion$, '', setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE()))
              )
            ]
          },
          {
            fieldGroupClassName: 'row',
            fieldGroup: [
              getInputField(
                "emergencyDetails.name",
                "Emergency contact name", setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE())
              ),
              getInputField(
                "emergencyDetails.relationship",
                "Emergency contact relationship", setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE())
              ),
              getInputField(
                "emergencyDetails.mobile",
                "Emergency contact mobile", setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE())
              )
            ]
          },
          {
            fieldGroupClassName: 'row',
            fieldGroup: [
              getInputField(
                "emergencyDetails.email",
                "Emergency contact email",setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE(), EmailValidator())
              ),
              getInputField(
                "emergencyDetails.name1",
                "Emergency contact name 2", setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE())
              ),
              getInputField(
                "emergencyDetails.relationship1",
                "Emergency contact relationship 2", setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE())
              )
            ]
          },
          {
            fieldGroupClassName: 'row',
            fieldGroup: [
              getInputField(
                "emergencyDetails.mobile1",
                "Emergency contact mobile 2", setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE())
              ),
              getInputField(
                "emergencyDetails.email1",
                "Emergency contact email 2", setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE(), EmailValidator())
              ), getInputField(
                "nationalities.cnicDetails",
                "CNIC",
                setAsHiddenWhen(() => !this.isRapidOrPakistan())),
                getDateField(
                  "nationalities.cnicExpiryDate",
                  "CNIC expiry date",
                  setAsHiddenWhen(() => !this.isRapidOrPakistan())
                ),
            ]
          },

          // {
          //   fieldGroupClassName: 'row',
          //   fieldGroup: [
          //     getSelectField(
          //       "insuranceDetils.insuranceExist.id",
          //       "Do you have an existing Medical Insurance plan?",
          //       this.common.getSelectFieldOptions(this.yesNo$, '', setAsHiddenWhen(this.isLocationLevant,
          //         setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE())))
          //     ),             
          //     getSelectField(
          //       "insuranceDetils.isItGovtInsurance.id",
          //       "If yes, is it provided by a Government entity?",
          //       this.common.getSelectFieldOptions(this.yesNo$, '',
          //         setRequiredForNotApplicableWhen((model) =>
          //           !this.isLocationLevant() && model.insuranceDetils.insuranceExist && model.insuranceDetils.insuranceExist.id == 1074,
          //          setAsHiddenWhen(this.isLocationLevant, setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE()))))
          //     ),
          //   ]
          // },

          {
            fieldGroupClassName: 'row',
            fieldGroup: [
              getSelectField(
                "travelPlans.isDependentsTravelling.id",
                "Do you have dependents travelling ?",
                this.common.getSelectFieldOptions(this.yesNo$, '', setAsHiddenWhen(() => !this.isInternationalHire()))
              ),
              getSelectField(
                "travelPlans.dependentTravelingCount.id",
                "Number of dependents",
                this.common.getSelectFieldOptions(this.dependents$, '', setAsHiddenWhen(() => !this.isInternationalHire()))
              ),
              getSelectField(
                "travelPlans.preferredTravelTime.id",
                "Preferred travel time?",
                this.common.getSelectFieldOptions(this.traveltime$, '', setAsHiddenWhen(() => !this.isInternationalHire()))
              ),
            ]
          },
          {
            fieldGroupClassName: 'row',
            fieldGroup: [

              getSelectField(
                "travelPlans.familyMembersRelocating.id",
                "Is family members relocating?",
                this.common.getSelectFieldOptions(this.yesNo$, '', setAsHiddenWhen(() => !this.isInternationalHire()))
              ),



              getTypeAheadAirportSelectField(
                "travelPlans.closestInternationalAirport",
                "Closest international airport",
                setAsHiddenWhen(() => !this.isInternationalHire())
              ),



            ]
          },
          {
            fieldGroupClassName: 'row',
            fieldGroup: [
              getSelectField(
                "itPersonalInfo.holdEmploymentVisa.id",
                "Do you currently hold an EY employment visa?",
                this.common.getSelectFieldOptions(this.yesNoNA$, '', setAsHiddenWhen(() => !this.isInternalTransfer(), setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE())))
              ),

              getSelectField(
                "itPersonalInfo.istravellingShortly.id",
                "Will you be travelling in the next two months? ",
                this.common.getSelectFieldOptions(this.yesNo$, '', setAsHiddenWhen(() => !this.isInternalTransfer()))
              ),
              getDateField(
                "itPersonalInfo.travellingDate",
                "Travel date",
                setAsHiddenWhen(() => !this.isInternalTransfer(),
                  setAsDisabledWhen((model) => {
                    if (model.itPersonalInfo.istravellingShortly.id === 1074) {
                      return false;
                    } else {
                      return true;
                    }
                  })
                )),
              getSelectField(
                "itPersonalInfo.travelLocation.id",
                "Travel location",
                this.common.getSelectFieldOptions(this.officeLocations$, '',
                  setAsHiddenWhen(() => !this.isInternalTransfer(),
                    setAsDisabledWhen((model) => {
                      if (model.itPersonalInfo.istravellingShortly.id === 1074) {
                        return false;
                      } else {
                        return true;
                      }
                    }))
                )),
              getInputField(
                "itPersonalInfo.tripDuration",
                "Trip duration",
                setAsHiddenWhen(() => !this.isInternalTransfer(),
                  setAsDisabledWhen((model) => {
                    if (model.itPersonalInfo.istravellingShortly.id === 1074) {
                      return false;
                    } else {
                      return true;
                    }
                  }))),
              getSelectField(
                "itPersonalInfo.isBusinessTrip.id",
                "Is this a business or a personal trip?",
                this.common.getSelectFieldOptions(this.shortTravelType$, '', setAsHiddenWhen(() => !this.isInternalTransfer(),
                    setAsDisabledWhen((model) => {
                      if (model.itPersonalInfo.istravellingShortly.id === 1074) {
                        return false;
                      } else {
                        return true;
                      }
                  })))
              ),
              getDateField(
                "itPersonalInfo.transferDate",
                "What is your expected transfer date based on discussions with your Manager/ Partner?",
                setAsHiddenWhen(() => !this.isInternalTransfer(), setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE()))
              ),
              getSelectField(
                "itPersonalInfo.isEngagedInAnyProject.id",
                "Are you currently engaged on any projects that must be completed before your transfer date?",
                this.common.getSelectFieldOptions(this.yesNo$, '', setAsHiddenWhen(() => !this.isInternalTransfer(), setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE())))
              ),
              getInputField(
                "itPersonalInfo.projectName",
                "Project name",
                setAsHiddenWhen(() => !this.isInternalTransfer(),
                  setAsDisabledWhen((model) => {
                    if (model.itPersonalInfo.isEngagedInAnyProject.id === 1074) {
                      return false;
                    } else {
                      return true;
                    }
                  }, setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE()))))
            ]
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              getSelectField(
                "itITInformation.haveCurrentOfficeEquipment.id",
                "Do you have an EY laptop/other IT equipment that has been provided by your current office?",
                this.common.getSelectFieldOptions(this.yesNo$, '', setAsHiddenWhen(() => !this.isInternalTransfer(), setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE())))
              ),
              getSelectField(
                "itITInformation.haveAccesstoMailbox.id",
                "Do you need access to your current mailbox after your transition period?",
                this.common.getSelectFieldOptions(this.yesNo$, '', setAsHiddenWhen(() => !this.isInternalTransfer(), setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE())))
              ),
              getSelectField(
                "itITInformation.dicussedRequirementWithITteam.id",
                "Have you discussed the IT requirement with your current office local IT team?",
                this.common.getSelectFieldOptions(this.yesNoNA$, '', setAsHiddenWhen(() => !this.isInternalTransfer(), setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE())))
              )
            ]
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              getSelectField(
                "itFinacialInformation.havingOutstandingLoans.id",
                "Do you have any outstanding loans with EY or payroll deductions in your current office?",
                this.common.getSelectFieldOptions(this.yesNo$, '', setAsHiddenWhen(() => !this.isInternalTransfer(), setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE())))
              ),
              getSelectField(
                "itFinacialInformation.haveOutstandingreimbursements.id",
                "Do you have any outstanding reimbursements or expenses on mercury?",
                this.common.getSelectFieldOptions(this.yesNo$, '', setAsHiddenWhen(() => !this.isInternalTransfer(), setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE())))
              ),
            ]
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              getSelectField(
                "itFinacialInformation.eosb.id",
                "End of service benefits (EOSB)",
                this.common.getSelectFieldOptions(this.eosb$, '', setAsHiddenWhen(() => !this.isInternalTransfer(),
                setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE(),this.common.AddTooltipToControl(FieldTooltip.EndOfServiceBenefit))
                ))
              ),
              getSelectField(
                "itFinacialInformation.isAmexCardAvailable.id",
                "Do you currently have an EY AMEX Card?",
                this.common.getSelectFieldOptions(this.yesNo$, '', setAsHiddenWhen(() => !this.isInternalTransfer(), setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE())))
              ),
              getInputField(
                "itFinacialInformation.amexCard",
                "EY AMEX Card number",
                setAsHiddenWhen(() => !this.isInternalTransfer(),
                  setAsDisabledWhen((model) => {
                    if (model.itFinacialInformation.isAmexCardAvailable.id === 1074) {
                      return false;
                    } else {
                      return true;
                    }
                  }, setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE()))))]
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              getSelectField(
                "itLeaveInformation.havingOutstandingLeave.id",
                "Do you have outstanding leave balance for the current financial year?",
                this.common.getSelectFieldOptions(this.yesNo$, '', setAsHiddenWhen(() => !this.isInternalTransfer(),
                 setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE(), this.common.AddTooltipToControl(FieldTooltip.LeaveBalanace))
               ))
              ),
              getSelectField(
                "itLeaveInformation.howToManageLeave.id",
                "How would you like to manage your outstanding leave balance?",
                this.common.getSelectFieldOptions(this.manageLeaveBalance$, '', setAsHiddenWhen(() => !this.isInternalTransfer(),
                  setAsDisabledWhen((model) => {
                    if (model.itLeaveInformation.havingOutstandingLeave.id === 1074) {
                      return false;
                    } else {
                      return true;
                    }
                  }, setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE()))))
              ),
              getInputField(
                "itLeaveInformation.totalDaysInFY",
                "How many days in total for this FY?",
                setAsHiddenWhen(() => !this.isInternalTransfer(),
                  setAsDisabledWhen((model) => {
                    if (model.itLeaveInformation.havingOutstandingLeave.id === 1074) {
                      return false;
                    } else {
                      return true;
                    }
                  }, setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE()))))]
          },

          {
            fieldGroupClassName: 'row',
            fieldGroup: [
              getInputField(
                "kinDetails.name",
                "Name of next of kin", setAsHiddenWhen(() => !this.isRapidOrPakistan(), this.common.AddTooltipToControl(FieldTooltip.KinDetails))
              ),
              getInputField(
                "kinDetails.relationship",
                "Relationship", setAsHiddenWhen(() => !this.isRapidOrPakistan())
              ),
              getInputField(
                "kinDetails.cnic",
                "CNIC number", setAsHiddenWhen(() => !this.isRapidOrPakistan())
              ),
              getInputField(
                "kinDetails.contactInfo",
                "Contact details (mobile/email)", setAsHiddenWhen(() => !this.isRapidOrPakistan())
              ),
              getInputField(
                "kinDetails.kiNaddress",
                "Address", setAsHiddenWhen(() => !this.isRapidOrPakistan())
              ),

            ]
          },
          {
            fieldGroupClassName: 'row',
            fieldGroup: [
              getSelectField(
                "familyBookDetails.haveFamilyBook.id",
                "Do you have a family book (Khulasat)?",
                this.common.getSelectFieldOptions(this.yesNo$, '', setAsHiddenWhen(() => !this.isUAENational(),
                  this.common.AddTooltipToControl(FieldTooltip.FamilyBookDetails)))
              ),
              getInputField(
                "familyBookDetails.familyNumber",
                "Family number", setAsHiddenWhen(() => !this.isUAENational())
              ),
              getInputField(
                "familyBookDetails.familyBookNumber",
                "Family book number", setAsHiddenWhen(() => !this.isUAENational())
              ),
              getInputField(
                "familyBookDetails.cityNumber",
                "City number", setAsHiddenWhen(() => !this.isUAENational())
              ),
              getInputField(
                "familyBookDetails.passportUIDnumber",
                "Passport UID number", setAsHiddenWhen(() => !this.isUAENational())
              ),
              getInputField(
                "familyBookDetails.idbaraNumber",
                "Idbara number", setAsHiddenWhen(() => !this.isUAENational())
              ),


              getSelectField(
                "choiceOfMedicalInsurance.id",
                "Choice of medical insurance",
                this.common.getSelectFieldOptions(
                  this.choiceOfInsurance$
                  // this.choiceOfInsurance$.pipe(filter(x=>this.officlck(x) ) )
                  , '', setAsHiddenWhen(() => {

                    return ((this.rank() && !['21', '61', '13', '63', '32', '62'].includes(this.rank())) ||
                      [715, 725].includes(this.modelDetails().employeeCategory.id))
                  })

                )),
                getSelectField(
                  "previousEmployee.id",
                  "Do you have any work experience?",
                   this.common.getSelectFieldOptions(this.previousEyExperience$, '',
                   this.common.displayPreviousEmploymentFileds(() => {
                    return !this.previousEmploymentFields()})
                  )), 
                
               getSelectField(
                 "previousEyEmployee.id",
                 "Have you ever worked for EY before?",
                 setPlaceholderNotApplicableWhen(
                   () => this.cw_contractTypesExcludingFTTE(),
                   this.common.getSelectFieldOptions(
                     this.yesNo$, 
                     '',
                     this.common.validatepreviousEmploymentFields(
                       !this.previousEmploymentFields()
                  )))),  
                   
                  getSelectField(
                    "previousBigFour.id",
                    "Have you worked for any 'other' Big Four previously?",
                      this.common.getSelectFieldOptions(this.yesNo$, '',
                        this.common.validatepreviousEmploymentFields(
                        !this.previousEmploymentFields(), setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE())
                      ))),
                
                  getInputField(
                    'lastEmployerDetail.lastEmployerName',
                    'Company Name',
                    this.common.validatepreviousEmploymentFields(
                        !this.previousEmploymentFields(), setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE())
                    )),
                  getSelectField(
                  'lastEmployerDetail.lastEmployerLocation.id',
                  'Location',
                   this.common.getSelectFieldOptions(this.countries$,'',
                   this.common.validatepreviousEmploymentFields(
                      !this.previousEmploymentFields(), setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE())
                    ))),
                  getDateField(
                    'lastEmployerDetail.lastEmployerStartDate',
                    'Start date',
                    this.common.validatepreviousEmploymentFields(
                        !this.previousEmploymentFields() ,setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE())
                      )),                 
                      getDateField(
                        'lastEmployerDetail.lastEmployerEndDate',
                        'End date', 
                        this.common.validateEndDate("End date must be greater than start date",'lastEmployerDetail.lastEmployerStartDate',
                        this.common.validatepreviousEmploymentFields(
                            !this.previousEmploymentFields() ,setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE())
                          ))
                      ),

                      getSelectField(
                        "registeredWithUAE.id",
                         "Have you ever been registered with the UAE pension authority?",
                          this.common.getSelectFieldOptions(this.yesNo$, '',
                          setAsHiddenWhen(() => {
                            return !([1046].includes(this.modelDetails().onboardingType.id) &&
                            [661, 654].includes(this.modelDetails().officeLocation.id))
                            })))
            ]
          },

          {
            fieldGroupClassName: "row",
            fieldGroup: [
              getArrayPickerField('spouseDetails', 'Spouse details', this.spouseDetails('spouse'), 'spouse', null, null, 'View',null,null,null,true),
              getArrayPickerField('childrenDetails', 'Child details', this.childrenDetails('children'), 'children', null, null, 'View',null,null,null,true),
              getArrayPickerField('priorBigFourEmployerDetail', 'Previous Big Four Experiences', this.PriorBigFourEmployerDetail('Big Four Experiences'), 'Previous Big Four Experience', null, null, 'View',null,null,null,true)            ]
          },
        ]
      },

    ];
  }

  private spouseDetails(_buttonAddText: string): FormlyFieldConfig[] {
    return (
      [
        {
          key: 'formData',
          type: 'repeat',
          templateOptions: {
            addText: `Add ${_buttonAddText}`,
          },
          fieldGroupClassName: "row",
          fieldArray: {
            fieldGroup: [
              {
                fieldGroupClassName: "row",
                fieldGroup: [
                  getInputField(
                    "firstName",
                    "First name (as per passport)",setPlaceholderNotApplicableWhen(()=>this.cw_contractTypesExcludingFTTE())
                  ),
                  getInputField(
                    "middleName",
                    "Middle name (as per passport)",setPlaceholderNotApplicableWhen(()=>this.cw_contractTypesExcludingFTTE())
                  ),
                  getInputField("lastName", "Last name (as per passport)",setPlaceholderNotApplicableWhen(()=>this.cw_contractTypesExcludingFTTE())
                  ),
                ]
              },
              {
                fieldGroupClassName: "row",
                fieldGroup: [
                  getSelectField("firstNationality.id", "Nationality", this.common.getSelectFieldOptions(this.countries$, '',setPlaceholderNotApplicableWhen(()=>this.cw_contractTypesExcludingFTTE()))),
                  getInputField("passportNumber", "Passport number",setPlaceholderNotApplicableWhen(()=>this.cw_contractTypesExcludingFTTE())),
                  getInputField("placeOfBirth", "Place of Birth",setPlaceholderNotApplicableWhen(()=>this.cw_contractTypesExcludingFTTE())),
                ]
              },
              {
                fieldGroupClassName: "row",
                fieldGroup: [
                  getDateField("dateOfBirth", 'Date of birth',setPlaceholderNotApplicableWhen(()=>this.cw_contractTypesExcludingFTTE())),
                  getDateField("passportExpiryDate", 'Passport expiry date',setPlaceholderNotApplicableWhen(()=>this.cw_contractTypesExcludingFTTE())),
                  getSelectField("dependentGender.id", "Gender", this.common.getSelectFieldOptions(this.genders$, '',setPlaceholderNotApplicableWhen(()=>this.cw_contractTypesExcludingFTTE()))),

                ]

              },
              {
                fieldGroupClassName: "row",
                fieldGroup: [
                  getSelectField("spouseMarriageCertAttested.id", "Marriage certificate attested", this.common.getSelectFieldOptions(this.yesNoNA$, '', setAsHiddenWhen((model) => {

                    if (model.firstNationality && this.isDependentNationalitySame(this.modelDetails().onboardingType.id, this.modelDetails().officeLocationCountry.id, this.modelDetails().nationality.id, model.firstNationality.id)) {
                      if (model.spouseMarriageCertAttested) {
                        model.spouseMarriageCertAttested.id = null;
                      }
                      return true;
                    } else {
                      return false;
                    }

                  }, 
                setPlaceholderNotApplicableWhen(() => this.cw_contractTypesExcludingFTTE(),
                 this.common.AddTooltipToControl(FieldTooltip.Attestedmarriagecertificate)
                 )))),
                  getSelectField("needSpouseDependentSponsor.id", "Sponsor needed", this.common.getSelectFieldOptions(this.yesNoNA$, '', setAsHiddenWhen((model) => {
                    if (model.firstNationality && this.isDependentNationalitySame(this.modelDetails().onboardingType.id, this.modelDetails().officeLocationCountry.id, this.modelDetails().nationality.id, model.firstNationality.id)) {
                      if (model.needSpouseDependentSponsor) {
                        model.needSpouseDependentSponsor.id = null;
                      }
                      return true;
                    } else {
                      return false;
                    }
                  }, setPlaceholderNotApplicableWhen(() => this.cw_contractTypesExcludingFTTE(),
                  this.common.AddTooltipToControl(FieldTooltip.Dependentsponsorship))))),

                  getInputField(
                    "cnicDetails",
                    "CNIC",
                    setAsHiddenWhen((model) => {
                      if (model.firstNationality && model.firstNationality.id === 176 && this.isRapidInnovation()) {
                        return false;
                      } else {
                        model.cnicDetails = "";
                        return true;
                      }
                    }, setPlaceholderNotApplicableWhen(() => this.cw_contractTypesExcludingFTTE())),
                  )
                  // getSelectField("spouseTravelAlong.id", "Dependents travel along", this.common.getSelectFieldOptions(this.yesNo$, '', this.common.AddTooltipToControl(FieldTooltip.Dependanttravel))),
                ]
              },
              {
                fieldGroupClassName: "row",
                fieldGroup: [
                  getInputField(
                    "dependentNationalIdNumber",
                    "National id number", setAsHiddenWhen(() => !this.isLevantNational(), setPlaceholderNotApplicableWhen(() => this.cw_contractTypesExcludingFTTE()))
                  ),
                  getInputField(
                    "dependentSocialSecurityNumber",
                    "Social security number", setAsHiddenWhen(() => !this.isLevantNational(), setPlaceholderNotApplicableWhen(() => this.cw_contractTypesExcludingFTTE()))
                  )
                ]
              }
            ]
          },
        },
      ]
    );
  }

private PriorBigFourEmployerDetail(_buttonAddText: string): FormlyFieldConfig[] {
  return (
    [
      {
        key: 'formData',
        type: 'repeat',
        templateOptions: {
          addText: `Add ${_buttonAddText}`,
        },
        fieldGroupClassName: "row",
        fieldArray: {
          fieldGroup: [
            {
              fieldGroupClassName: "row",
              fieldGroup: [
                getSelectField(
                  "bigFourcompanyName.id",
                  "Company Name",
                  this.common.getSelectFieldOptions(
                    this.bigFourCompanies$,
                    '',
                    setPlaceholderNotApplicableWhen(() => this.cw_contractTypesExcludingFTTE())
                  )
                ),
                getSelectField(
                  "bigFourlocation.id",
                  "Location",
                  this.common.getSelectFieldOptions(
                    this.countries$,
                    '',
                    setPlaceholderNotApplicableWhen(() => this.cw_contractTypesExcludingFTTE())
                  )
                ),
                getDateField(
                  "bigFourstartDate",
                  "Start date",
                  setPlaceholderNotApplicableWhen(() => this.cw_contractTypesExcludingFTTE())
                ),
              ]
            },
            {
              fieldGroupClassName: "row",
              fieldGroup: [
                getDateField(
                  "bigFourendDate",
                  "End date",
                  setPlaceholderNotApplicableWhen(() => this.cw_contractTypesExcludingFTTE())
                ),
                getBigFourExpCheckboxNonMandatory(
                  "bigFourcurrentlyEmployed",
                  "Currently Employed",null,
                  setPlaceholderNotApplicableWhen(() => this.cw_contractTypesExcludingFTTE())
                ),
              ]
            },
          ]
        },
      },
    ]
  );
}
  private academicDetails(_buttonAddText: string): FormlyFieldConfig[] {
    return (
      [
        {
          key: 'formData',
          type: 'repeat',
          templateOptions: {
            addText: `Add ${_buttonAddText}`,
          },
          fieldGroupClassName: "row",
          fieldArray: {
            fieldGroup: [
              {
                fieldGroupClassName: "row",              
                fieldGroup: [
                  getInputField(
                "academicQualification",
                "Academic qualification(s) ",setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE())
              ),
                 getSelectField("modeOfStudy.id", "Mode of Study", this.common.getSelectFieldOptions(this.modeOfStudy$, '',setPlaceholderNotApplicableWhen(()=> this.cw_contractTypesExcludingFTTE())))
         
            ]},
              {
                fieldGroupClassName: "row",  
                 className: "col-md-6",            
               fieldGroup: [
                getSelectField(
                 "academicQualificationAttested.id",
                  "Attested Academic qualification",
                  this.common.getSelectFieldOptions(this.yesNoInitated$,'',
                  setAsHiddenWhen(
                  this.validateAcademicAttesation,
                  setPlaceholderNotApplicableWhen(() => this.cw_contractTypesExcludingFTTE(),
                  this.common.AddTooltipToControl(FieldTooltip.AttestedAcademicqualification))))),              
                   getDateField(
                "attestationCompletedDate",
                "Attestation completion date" ,
                setAsHiddenWhen(this.validateAcademicAttesation,setAsDisabledWhenWithOutVal((model)=>
                model.academicQualificationAttested?.id && model.academicQualificationAttested?.id!=15217
                 , setPlaceholderNotApplicableWhen(() => this.cw_contractTypesExcludingFTTE())))
                 ),
                ]
              }            

            ]
          },
        },
      ]
    );
  }

private childrenDetails(_buttonAddText: string): FormlyFieldConfig[] {
  return (
    [
      {
        key: 'formData',
        type: 'repeat',
        templateOptions: {
          addText: `Add ${_buttonAddText}`,
        },
        fieldGroupClassName: "row",
        fieldArray: {
          fieldGroup: [
            {
              fieldGroupClassName: "row",
              fieldGroup: [
                getInputField(
                  "firstName",
                  "First name (as per passport)",
                  setPlaceholderNotApplicableWhen(() => this.cw_contractTypesExcludingFTTE())
                ),
                getInputField(
                  "middleName",
                  "Middle name (as per passport)",
                  setPlaceholderNotApplicableWhen(() => this.cw_contractTypesExcludingFTTE())
                ),
                getInputField(
                  "lastName",
                  "Last name (as per passport)",
                  setPlaceholderNotApplicableWhen(() => this.cw_contractTypesExcludingFTTE())
                ),
              ]
            },
            {
              fieldGroupClassName: "row",
              fieldGroup: [
                getSelectField(
                  "firstNationality.id",
                  "Nationality",
                  this.common.getSelectFieldOptions(
                    this.countries$,
                    '',
                    setPlaceholderNotApplicableWhen(() => this.cw_contractTypesExcludingFTTE())
                  )
                ),
                getInputField(
                  "passportNumber",
                  "Passport number",
                  setPlaceholderNotApplicableWhen(() => this.cw_contractTypesExcludingFTTE())
                ),
                getInputField(
                  "placeOfBirth",
                  "Place of Birth",
                  setPlaceholderNotApplicableWhen(() => this.cw_contractTypesExcludingFTTE())
                ),
              ]
            },
            {
              fieldGroupClassName: "row",
              fieldGroup: [
                getDateField(
                  "dateOfBirth",
                  'Date of birth',
                  setPlaceholderNotApplicableWhen(() => this.cw_contractTypesExcludingFTTE())
                ),
                getDateField(
                  "passportExpiryDate",
                  'Passport expiry date',
                  setPlaceholderNotApplicableWhen(() => this.cw_contractTypesExcludingFTTE())
                ),
                getSelectField(
                  "dependentGender.id",
                  "Gender",
                  this.common.getSelectFieldOptions(
                    this.genders$,
                    '',
                    setPlaceholderNotApplicableWhen(() => this.cw_contractTypesExcludingFTTE())
                  )
                )
              ]
            },
            {
              fieldGroupClassName: "row",
              fieldGroup: [
                getSelectField(
                  "childBirthCertAttested.id",
                  "Child birth certificate attested",
                  this.common.getSelectFieldOptions(
                    this.yesNoNA$,
                    '',
                    setAsHiddenWhen((model) => {
                      if (
                        model.firstNationality &&
                        this.isDependentNationalitySame(
                          this.modelDetails().onboardingType.id,
                          this.modelDetails().officeLocationCountry.id,
                          this.modelDetails().nationality.id,
                          model.firstNationality.id
                        )
                      ) {
                        if (model.childBirthCertAttested) {
                          model.childBirthCertAttested.id = null;
                        }
                        return true;
                      } else {
                        return false;
                      }
                    },
                    setPlaceholderNotApplicableWhen(() => this.cw_contractTypesExcludingFTTE(),
                      this.common.AddTooltipToControl(FieldTooltip.AttestedChildBirthCertificate)
                    ))
                  )
                ),
                getSelectField(
                  "needChildDependentSponsor.id",
                  "Sponsor needed",
                  this.common.getSelectFieldOptions(
                    this.yesNoNA$,
                    '',
                    setAsHiddenWhen((model) => {
                      if (
                        model.firstNationality &&
                        this.isDependentNationalitySame(
                          this.modelDetails().onboardingType.id,
                          this.modelDetails().officeLocationCountry.id,
                          this.modelDetails().nationality.id,
                          model.firstNationality.id
                        )
                      ) {
                        if (model.needChildDependentSponsor) {
                          model.needChildDependentSponsor.id = null;
                        }
                        return true;
                      } else {
                        return false;
                      }
                    },
                    setPlaceholderNotApplicableWhen(() => this.cw_contractTypesExcludingFTTE(),
                      this.common.AddTooltipToControl(FieldTooltip.Dependentsponsorship)
                    ))
                  )
                ),
                getInputField(
                  "cnicDetails",
                  "CNIC",
                  setAsHiddenWhen((model) => {
                    if (
                      model.firstNationality &&
                      model.firstNationality.id === 176 &&
                      this.isRapidInnovation()
                    ) {
                      return false;
                    } else {
                      model.cnicDetails = "";
                      return true;
                    }
                  }, setPlaceholderNotApplicableWhen(() => this.cw_contractTypesExcludingFTTE()))
                ),
              ]
            },
            {
              fieldGroupClassName: "row",
              fieldGroup: [
                getInputField(
                  "dependentNationalIdNumber",
                  "National id number",
                  setAsHiddenWhen(() => !this.isLevantNational(), setPlaceholderNotApplicableWhen(() => this.cw_contractTypesExcludingFTTE()))
                ),
                getInputField(
                  "dependentSocialSecurityNumber",
                  "Social security number",
                  setAsHiddenWhen(() => !this.isLevantNational(), setPlaceholderNotApplicableWhen(() => this.cw_contractTypesExcludingFTTE()))
                )
              ]
            }
          ]
        },
      },
    ]
  );
}

  isDependentNationalitySame(pbTypeId, officeCountryid, ParentNationalityId, DependentNationalityId) {
    if (officeCountryid === 5897 && pbTypeId === 1046 && ParentNationalityId === 176 && DependentNationalityId === 176) {
      return true;
    }
    if (this.isLevantNational() && this.isNationalityLevantCountry(ParentNationalityId) && this.isNationalityLevantCountry(DependentNationalityId) && ParentNationalityId === DependentNationalityId) {
      return true;
    }
    return false;
  }

  isNationalityLevantCountry(nationalityId) {
    if ([73, 113, 121, 131, 134, 178].includes(nationalityId)) {
      return true;
    }
  }
  isUAENational() {
    return nullSafe(() => this.modelDetails().nationality.id == 241, false);
  }
  previousEmploymentFields(){
    return  ([5971, 711, 713].includes(this.modelDetails().employeeCategory?.id)
                    || (this.modelDetails().contractType?.id == 1063 && this.modelDetails().employeeCategory?.id == 725)) 
  }
  //this.immigrationCaseType$.pipe(map(items => model && model.officeLocationCountry.id == 1048 ? (model.onboardingType.id == 1045 ? (items.filter(f => [1010].includes(f.id))) : (items.filter(f => [1005, 1016, 1017].includes(f.id)))) : items))
  private getImmigrationTypes(model: CandidateProfile) {
    if (model) {
      var country = model.officeLocationCountry.id;
      var pbTypeId = model.onboardingType.id;

      switch (country) {
        case 1047:
          return this.immigrationCaseType$.pipe(map(items => items.filter(f => [1001, 1004, 1005, 1008, 1009, 1011, 1012, 1013, 1014, 1015, 1018, 1019, 12210, 12211,15068].includes(f.id))));
          break;
        case 1048:
          return this.immigrationCaseType$.pipe(map(items => items.filter(f => [1001, 1002, 1003, 1005, 1010, 1016, 1017, 12271].includes(f.id))));
          break;
        case 1050:
          return this.immigrationCaseType$.pipe(map(items => items.filter(f => [1001, 1002, 1003, 1005, 1010, 1011, 1012, 1016, 1017].includes(f.id))));
          break;
        case 1049:
          return this.immigrationCaseType$.pipe(map(items => items.filter(f => [1001, 1002, 1003, 1004, 1005, 1008, 1009, 1010, 1011, 1012, 1016, 1017, 12025, 12026].includes(f.id))));
          break;
        case 1052:
          return this.immigrationCaseType$.pipe(map(items => items.filter(f => [1001, 1002, 1003, 1004, 1005, 1010, 1011, 1012, 1016, 12271].includes(f.id))));
          break;
        case 1051:
          return this.immigrationCaseType$.pipe(map(items => items.filter(f => [1001, 1002, 1003, 1004, 1005, 1010, 1011, 1012, 1016,12211].includes(f.id))));
          break;
        case 1053:
          return this.immigrationCaseType$.pipe(map(items => items.filter(f => [1004,1005,1010,12270].includes(f.id))));
          break;
        case 1054:
          return this.immigrationCaseType$.pipe(map(items => items.filter(f => [1004,1005,1010,12270].includes(f.id))));
          break;
        case 1055:
        case 6250:         
        case 6251:         
        case 6252:  
          if(pbTypeId == 1045){
            return this.immigrationCaseType$.pipe(map(items => items.filter(f => [1004,1005,12270].includes(f.id))));
          }else{
            return this.immigrationCaseType$.pipe(map(items => items.filter(f => [1010,12270].includes(f.id))));
          }
          break;                
        default:
          return this.immigrationCaseType$;
          break;
      }
    } else {
      return this.immigrationCaseType$;
    }
  }

  private getTransferTypes(model: CandidateProfile) {
    if (model) {
      var country = model.officeLocationCountry.id;

      switch (country) {
        case 13410:
          return this.transferType$.pipe(map(items => items.filter(f => [13183, 13184, 13185, 13186, 13187, 13188, 13189, 13190].includes(f.id))));
          break;
        default:
          return this.transferType$.pipe(map(items => items.filter(f => [975, 976, 977, 978, 979, 980, 981, 982, 5947, 5948, 6129, 6130].includes(f.id))));
          break;
      }
    } else {
      return this.immigrationCaseType$;
    }
  }
  
  private getCurrentVisaStatus(model: CandidateProfile) {
    if (model) {
      var country = model.officeLocationCountry.id;

      switch (country) {
        case 1051:
          return this.currentVisaStatus$;
        
        default:
          return this.currentVisaStatus$.pipe(map(items => items.filter(f => ![15030].includes(f.id))));;
          break;
      }
    }
  }  
}
